var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 4.25L3.1875 19.25C3.23203 20.1167 3.8625 20.75 4.6875 20.75H13.3125C14.1408 20.75 14.7595 20.1167 14.8125 19.25L15.75 4.25M0.75 4.25H17.25M6 4.25V2.375C5.99957 2.22715 6.02837 2.08066 6.08475 1.94397C6.14114 1.80729 6.22399 1.6831 6.32854 1.57854C6.43309 1.47399 6.55728 1.39114 6.69397 1.33476C6.83066 1.27838 6.97714 1.24957 7.125 1.25H10.875C11.0229 1.24957 11.1693 1.27838 11.306 1.33476C11.4427 1.39114 11.5669 1.47399 11.6715 1.57854C11.776 1.6831 11.8589 1.80729 11.9152 1.94397C11.9716 2.08066 12.0004 2.22715 12 2.375V4.25M9 7.25001V17.75M5.625 7.25001L6 17.75M12.375 7.25001L12 17.75",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.b685e8b779d0ba0b9a69d6dfb323af7d.svg";
export { ForwardRef as ReactComponent };